import React from "react";

export function LoadingPage() {

  return (
    <div className="account">
      <div className="edge trim">
        <div className="account__container">
          <div className="account-menu account-menu--is-loading component">
          </div>
          <div className="account-page account-loading">
            <div className="account-loading__loading-throbber"></div>
            <span className="account-loading__text">Getting your account details...</span>
          </div>
        </div>
      </div>
    </div>
  );
}
